import React, { useEffect, useRef, useState } from 'react'

// react router
import { useParams } from 'react-router-dom'

// utility
import KycModal from '../../helpers/KycModal'

// components
import Orders from '../components/Orders/Orders'
import DesktopChart from '../components/DesktopChart'
import TradingChart from '../old-components/TradingChart'
import Orderbook from '../components/Orderbook/Orderbook'
import MarketForm from '../components/MarketForm/MarketForm'
import MarketsList from '../components/MarketsList/MarketsList'
import RecentTrades from '../components/RecentTrades/RecentTrades'
import MarketInsight from '../components/MarketInsight/MarketInsight'
import ExchangeFooter from '../components/ExchangeFooter/ExchangeFooter'
import MobileTabSwitcher from '../components/MobileTabSwitcher/MobileTabSwitcher'

// redux
import { useDispatch, useSelector } from 'react-redux'
import { addOrder } from '../redux/slices/openOrdersSlice'
import { addOrderBook } from '../redux/slices/orderBookSlice'
import { addTrade, changeTrade } from '../redux/slices/tradesSlice'
import { setMarketTickers } from '../redux/slices/marketTickersSlice'
import { setSelectedMarket } from '../redux/slices/selectedMarketSlice'
import { _getMarketTrades, _getBalances, _getOpenOrders } from '../redux/actions'
import { setSnackbarOpen, setSnackbarData } from '../../snackbar/redux/snackbarSlice'

// styles
import Styles from './Exchange.module.css'

function Exchange() {
  const dispatch = useDispatch()

  const markets = useSelector(state => state.marketList?.value)
  const { marketName } = useParams()
  // ** States
  const selectedMarket = useSelector(state => state.selectedMarket.value)
  const selectedMarketRef = useRef(selectedMarket)
  const previousMarket = useSelector(state => state.previousMarket.value)
  const exchangeName = useSelector(state => state.exchangeCustomization.value.name)

  document.title = `WealthTech: Trading`

  const theme = useSelector(state => state.theme.value)

  // ----- RESPONSIVENESS STATE ---------
  // ------------------------------------
  const [isTabletView, setIsTabletView] = useState(window.innerWidth < 990)
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 990)

  const handleResize = () => {
    setIsMobileView(window.innerWidth < 990)
    setIsTabletView(window.innerWidth < 990)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    _getMarketTrades(
      selectedMarket.id,
      data => {
        dispatch(changeTrade(data))
      },
      err => {}
    )
  }, [selectedMarket])
  // ------------------------------------
  // ------------------------------------

  // MOBILE TABS STATES -----------------
  const [selectedMobileTab, setSelectedMobileTab] = useState('Chart')
  // ------------------------------------

  useEffect(() => {
    // console.log(markets.find((market) => market.id === marketName))
    // console.log(markets.find((market) => market.id === marketName)?.quote_symbol)
    if (marketName) {
      // if (markets.length > 0) {
      //   setSelectedMarket(markets.find((market) => market.id === marketName))
      // } else {
      dispatch(
        setSelectedMarket({
          id: marketName,
          name: markets.find(market => market.id === marketName)?.name,
          quote_symbol: markets.find(market => market.id === marketName)?.quote_symbol,
          price_precision: markets.find(market => market.id === marketName)?.price_precision || 0,
          quote_unit: markets.find(market => market.id === marketName)?.quote_unit,
          base_unit: markets.find(market => market.id === marketName)?.base_unit
        })
      )
      // }
      // setSelectedMarket(markets.find((market) => market.id === marketName))
    }
  }, [marketName])

  return (
    <div>
      <div className={`${Styles.pageContainer}`}>
        {/* LEFT CONTAINER */}
        <div className={`${Styles.leftContainer}`}>
          <MarketsList />
        </div>

        {/* RIGHT CONTAINER - TAKES 100% OF REMAINING SPACE */}
        <div className={Styles.rightContainer}>
          {/* MarketInsight at the top */}
          <MarketInsight />

          {/* Chart and Orderbook/RecentTrades in horizontal layout */}
          {!isMobileView && (
            <div className={Styles.chartAndOrderbookContainer}>
              <div className={Styles.chartContainer}>
                <DesktopChart />
                {!isTabletView && <MarketForm />}
              </div>
              <div className={Styles.orderbookTradesContainer}>
                <Orderbook />
                <RecentTrades />
              </div>
            </div>
          )}

          {/* Mobile view */}
          {isMobileView && (
            <MobileTabSwitcher selectedMobileTab={selectedMobileTab} setSelectedMobileTab={setSelectedMobileTab} />
          )}
        </div>
      </div>

      <div className={Styles.ordersContainer}>
        <Orders />
      </div>

      {/* FOOTER */}
      <ExchangeFooter />
    </div>
  )
}

export default Exchange
